/** Vraies données pour les chapitres « fiche » : ce que la personne voit déjà dans ses listes. */
import { apiFetch, readApiJson } from '../lib/api';
import { ficheId } from '../lib/ficheParc';

// Id du premier ticket visible pour ce tri (null si aucun, ou si la lecture échoue).
async function premierTicket(qs) {
  try {
    const res = await apiFetch(`/api/tk/tickets?per_page=1&page=1&${qs}`).then(readApiJson);
    const t = (res && res.tickets && res.tickets[0]) || null;
    return t && t.id ? t.id : null;
  } catch {
    return null;
  }
}

export async function preparer(cle) {
  try {
    if (cle === 'ticket') {
      // D'abord le ticket RÉSOLU le plus récent : il porte ses tâches (pastille FACT. / NON FACT.
      // de l'étape « Facturer ») et illustre la résolution. Le dernier ticket créé, souvent tout
      // neuf et sans tâche, n'est qu'un repli (ruling du 05/10/2026).
      const id = (await premierTicket('status=resolved&sort_by=resolved_at&sort_dir=desc'))
        || (await premierTicket('sort_by=created_at&sort_dir=desc'));
      return id ? { ticketId: id } : {};
    }
    if (cle === 'poste') {
      const res = await apiFetch('/api/parc/unified-devices').then(readApiJson);
      const postes = (res && res.devices) || [];
      const joignable = postes.find((d) => /^\d+$/.test(String(d.rustdesk_id || '')));
      const choisi = joignable || postes[0];
      const id = choisi ? ficheId(choisi) : null;
      return id ? { posteId: id } : {};
    }
  } catch { /* rien à montrer */ }
  return {};
}
